import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Requester, type RequesterConstructor } from './Requester'
import { PrimaryCategoryFactory } from '../PrimaryCategory/PrimaryCategory.factory'
import { SecondaryCategoryFactory } from '../SecondaryCategory/SecondaryCategory.factory'

export const RequesterConstructorFactory =
  Factory.Sync.makeFactory<RequesterConstructor>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    profileImage: Factory.each(() => faker.image.avatar()),
    primaryCategory: Factory.each(() => PrimaryCategoryFactory.build()),
    secondaryCategory: Factory.each(() => SecondaryCategoryFactory.build()),
  })

export const RequesterFactory = EntityFactory(
  Requester,
  RequesterConstructorFactory
)
